export interface DocumentItem {
    id: string;
    nome: string;
    tipologia: string;
    percorso: string;
    stato: string;
    dimensione: number
    data: string;
}

export interface Task {
    taskId: string;
}

export interface IngestionDto {
    indexName: string;
    docs: string[];
    action: 'replace' | 'keep';
}

export interface IngestionResponse {
  status: 'STARTED' | 'DUPLICATES_FOUND'; 
  taskId?: string;
  conflictType?: 'HASH_CONFLICT' | 'PATH_CONFLICT';
  conflicts?: ConflictItem[];
  hashConflicts: ConfigItem[];
  pathConflicts: ConfigItem[];
}

// Descrive il singolo file in conflitto
export interface ConflictItem {
  incomingFile: string;
  existingFile: string;
  incomingHash?: string; // Presente solo se è un HASH_CONFLICT
}
export interface TaskMetadata {
  type?: string;
  totalFiles?: number;
}
export interface ScanResult {
  status: 'SUCCESS' | 'ERROR';
  fileName: string;
  message?: string; 
  type?: string;    
  error?: string;
  totalChunks?: number; 
  fileId?: string;
  url?: string;   
  syncStatus?: 'ADDED' | 'UPDATED' | 'UNCHANGED' | 'DELETED';
}
export interface IndexItem {
    _id: string | number;
    name: string;
    description?: string;
    provider: string;
    embedder: string;
    createdAt: string;
    isEphemeral?: boolean;
    userId?: string;
    sessionToken?: string;
    metadata?: Record<string, any>;
}

const UUID_PATTERN = '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}';
const EPHEMERAL_INDEX_REGEX = new RegExp(`^(${UUID_PATTERN}|.+)_${UUID_PATTERN}$`);

export function isEphemeralIndexName(name?: string | null): boolean {
  if (!name) return false;
  return EPHEMERAL_INDEX_REGEX.test(name);
}

export function isEphemeralIndex(item?: { name?: string; isEphemeral?: boolean; metadata?: any } | string | null): boolean {
  if (!item) return false;
  if (typeof item === 'string') {
    return isEphemeralIndexName(item);
  }
  if (item.isEphemeral === true || item.metadata?.isEphemeral === true) {
    return true;
  }
  return isEphemeralIndexName(item.name);
}
  
export interface CreateIndexDto {
    name: string;
    description?: string;
    embedder: string;
    provider: string;
  }
  
  export interface ConfigItem {
    name: string;
  }

  export interface TableItem {
    isFolder: boolean;
    name: string;
    fullPath: string;
    document?: any;
    isIndexFolder?: boolean;
  }
  export interface UploadItem {
    file: File;
    path: string;
  }
  
  export enum FileStatus {
    PENDING = 'PENDING',
    MOVING = 'MOVING',
    PROCESSED = 'PROCESSED',
    FAILED = 'FAILED',
}

export enum TaskStatus {
  WAITING = 'waiting',
  ACTIVE = 'active',
  COMPLETED = 'completed',
  FAILED = 'failed',
  DELAYED = 'delayed',
  PAUSED = 'paused',
}

export interface FileRecord {
    id: string;           // L'UUID del file
    fileName: string;     // Il nome del file (es. documento.pdf)
    status: FileStatus;   // Lo stato attuale del file
    sourcePath?: string;  // Il percorso originale (es. input/documento.pdf)
    currentPath?: string; // Il percorso attuale (es. processed/ o error/...)
    error?: string;       
    createdAt: Date | string;
    updatedAt: Date | string;
}

export interface WebPage {
  id: string;
  siteId: string;
  url: string;
  title: string;
  status: string;
  previewPath?: string;
}

export interface Website {
  id: string;
  url: string;
  status: string;
  type: string;
  pages: WebPage[];
}

export interface WebsiteIndex {
  indexName: string;
  sites: Website[];
}

export interface WebIngestionDto {
  urls: string[];
  indexName: string;
  type?: 'cheerio' | 'playwright' | 'auto';
  action?: 'replace' | 'keep';
  maxPages?: number;
  generatePreview?: boolean;
}